<template>
    <div class="col-md-3 left_col menu_fixed mCustomScrollbar _mCS_1 mCS-autoHide" style="overflow: visible;">
        <div class="left_col scroll-view">
            <div class="navbar nav_title" style="border: 0;">
                <router-link :to="{name: 'Home'}" class="site_title">
                    <i class="fa fa-paw"></i> <span>{{(panelData.com_name).toUpperCase()}}</span>
                </router-link>
            </div>
            <div class="clearfix"></div>
            <!-- menu profile quick info -->
            <div class="profile clearfix">
                <div class="profile_pic">
                    <img class="img-circle profile_img" alt="...." :src="logoImage">
                </div>
                <div class="profile_info">
                    <span>Welcome,</span>
                    <h2>{{userData.reseller.full_name}}</h2>
                </div>
            </div>
            <!-- /menu profile quick info -->

            <br/>

            <!-- sidebar menu -->
            <div class="navbar_statistics">
                <div v-if="com_user_type_access([0,1])">
                    <span class="db_statistics">{{pinWordReplacementWith}} : </span>
                    <span> {{pinAmount}}</span></div>
            </div>
            <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
                <div class="menu_section">
                    <h3>General</h3>
                    <ul class="nav side-menu">
                        <li :class="DashboardActive==true?'active':''">
                            <router-link :to="{name: 'Home'}">
                                <i class="fa fa-home"></i>
                                <span>Dashboard</span>
                            </router-link>
                        </li>
                        <li :class="clientActive==true?'treeview active':'treeview'" v-if="com_user_type_access([0,1])"
                        >
                            <a><i :class="clientActive==true?'treeview active':'treeview'"
                                  v-if="com_user_type_access([0,1])" class="fa fa-user-secret"></i>Clients
                                <span
                                        class="fa fa-chevron-down"></span></a>
                            <ul class="nav child_menu">
                                <li v-if="reseller_access" @click="clicked($event)">
                                    <router-link :to="{name: 'ResellerLists'}">
                                        <i class="fa fa-exchange"></i>
                                        <span>Agent</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)">
                                    <router-link :to="{name: 'PinLists'}">
                                        <i class="fa fa-list"></i>
                                        <span>Single {{pinWordReplacementWith}}</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)">
                                    <router-link :to="{name: 'ResellerConnectedUsers'}">
                                        <i class="fa fa-link"></i>
                                        <span>Connected {{pinWordReplacementWith}}</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1], false, [1])">
                                    <router-link :to="{name: 'AddPinBatchs'}">
                                        <i class="fa fa-tasks"></i>
                                        <span>Add {{pinWordReplacementWith}} Batch</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1], false, [1])">
                                    <router-link :to="{name: 'PinBatchLists'}">
                                        <i class="fa fa-tasks"></i>
                                        <span>{{pinWordReplacementWith}} Batch</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li :class="settingsActive==true?'treeview active':'treeview'"
                            v-if="setting_access && com_user_type_access([0,1])">
                            <a><i :class="rateActive==true?'treeview active':'treeview'"
                                  v-if="com_user_type_access([0,1])" class="fa fa-cog"></i>Settings
                                <span
                                        class="fa fa-chevron-down"></span></a>
                            <ul class="nav child_menu">
                                <li @click="clicked($event)">
                                    <router-link :to="{name: 'AddPanelSettings'}">
                                        <i class="fa fa-columns" aria-hidden="true"></i>
                                        <span>Panel</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)">
                                    <router-link :to="{name: 'BaseRatePlans'}">
                                        <i class="fa fa-bar-chart"></i>
                                        <span>Validity Plan</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="menu_section">
                    <h3>Reports</h3>
                    <ul class="nav side-menu">
                        <li li :class="reportsActive==true?'treeview active':'treeview'">
                            <a><i class="fa fa-pie-chart"></i>{{pinWordReplacementWith}}<span
                                    class="fa fa-chevron-down"></span></a>
                            <ul class="nav child_menu">
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1])">
                                    <router-link :to="{name: 'PinSubscriptionReportView'}">
                                        <i class="fa fa-pagelines"></i>
                                        <span>{{pinWordReplacementWith}}</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1])">
                                    <router-link :to="{name: 'IndividualSoldPinReportView'}">
                                        <i class="fa fa-users"></i>
                                        <span>Agent Wise {{pinWordReplacementWith}}</span>
                                    </router-link>
                                </li>
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1])">
                                    <router-link :to="{name: 'HourlySubscriptionReportView'}">
                                        <i class="fa fa-clock-o"></i>
                                        <span>Hourly Subscription</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="nav side-menu">
                        <li li :class="reportsActive==true?'treeview active':'treeview'">
                            <a><i class="fa fa-credit-card"></i>Transaction<span
                                    class="fa fa-chevron-down"></span></a>
                            <ul class="nav child_menu">
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1])">
                                    <router-link :to="{name: 'ResellerTransactionReportView'}">
                                        <i class="fa fa-money"></i>
                                        <span>Transaction</span>
                                    </router-link>
                                </li>
<!--                                <li @click="clicked($event)" v-if="com_user_type_access([0,1]) && allowOnlineReport">-->
<!--                                    <router-link :to="{name: 'OnlineTransactionReportView'}">-->
<!--                                        <i class="fa fa-circle text-success"></i>-->
<!--                                        <span>Online Transaction</span>-->
<!--                                    </router-link>-->
<!--                                </li>-->
                                <li @click="clicked($event)" v-if="com_user_type_access([0,1])">
                                    <router-link :to="{name: 'PaymentReportView'}">
                                        <i class="fa fa-credit-card"></i>
                                        <span>Payment</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

            </div>
            <!-- /sidebar menu -->

            <!-- /menu footer buttons -->
            <div class="sidebar-footer hidden-small">
                <router-link title="Panel Settings" :to="{name: 'AddPanelSettings'}">
                    <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
                </router-link>
                <a data-toggle="tooltip" data-placement="top" title="Logout" @click="logout">
                    <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
                </a>
            </div>
            <!-- /menu footer buttons -->
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: "LeftSideBar",
        data() {
            return {
                pinWordReplacementWith: process.env.VUE_APP_PIN_WORD_REPLACEMENT_WITH,
                userData: {},
                balance: 0,
                pinAmount: 0,
                setting_access: false,
                reseller_access: false,
                logoImage: '/new_assets/images/img.jpg',
                api_public_path: process.env.VUE_APP_APIRESELLERPUBLIC,
                reportsActive: false,
                rateActive: false,
                clientActive: false,
                settingsActive: false,
                DashboardActive: false,
                affDashboardActive: false,
                campaignActive: false,
                allowOnlineReport: false,
                flexActive: false,
                showParentUL: true
            };
        },
        created() {
            this.imageFilter();
            this.activeInactiveSideBar();
            this.setting_access = this.com_verifyAllowOrNotSetting();

            var rootObject = this;
            var encryptedData = this.$store.getters.getUser;
            var decodedString = this.com_DecryptString(encryptedData);
            var userData = JSON.parse(decodedString);
            if (userData.user_level != 1) {
                this.reseller_access = true;
            }

            this.allowOnlineReport = this.com_onlineReportAccess();

            this.userData = userData;
            var balance = parseInt(userData.reseller.balance * 10000) / 10000;
            this.balance = balance;

            var rateplanid = userData.reseller.rate_plan_id;
            axios.get('pixvpn-base-rate').then(function (response) {
                //validity plan set into store
                var validityPlans = response.data;
                var basePrice = response.data[0].price;
                rootObject.$store.dispatch('setValidityPlans', validityPlans);
                rootObject.$store.dispatch('setBasePrice', basePrice);
                rootObject.pinAmount = parseInt(balance / basePrice);
            })
                .catch(function (error) {
                    let alertmessage = "";
                    console.log(error);
                    // for (var prop in error.response.data) {
                    //     alertmessage += ' ' + error.response.data[prop]
                    // }
                    // console.log(alertmessage);
                });
        },
        methods: {
            clicked(event) {
                if (window.innerWidth <= 820) {
                    let ul = event.target.parentNode.parentNode.parentNode;
                    console.log(ul.className);
                    if (ul.className == "nav child_menu") {
                        ul.style.display = "none";
                    }
                }
            },
            imageFilter() {
                var rootObject = this;
                var PanelData = this.$store.getters.getPanelData;
                var logoImgURL = this.api_public_path + 'uploads/images/' + PanelData.logo_images;
                this.checkIfImageExists(logoImgURL, (exists) => {
                    if (exists) {
                        rootObject.logoImage = logoImgURL;
                    }
                });
            },
            checkIfImageExists(url, callback) {
                const img = new Image();
                img.src = url;
                if (img.complete) {
                    callback(true);
                } else {
                    img.onload = () => {
                        callback(true);
                    };
                    img.onerror = () => {
                        callback(false);
                    };
                }
            },
            logout(e) {
                //loader.hide();
                e.preventDefault();
                let rootObject = this;
                let loginparam = {
                    'jwt_token': '',
                    'redirect_url': 'login',
                };
                rootObject.com_setLoginData(loginparam);
            },
            calculatePinAmount(response) {
                //console.log(response);
                for (var prop in response) {
                    if (response[prop]['no_of_days'] == 30) {
                        this.pinAmount = parseInt(this.balance / this.basePrice);
                    }
                }
            },

            activeInactiveSideBar() {
                let routeName = this.$route.name;
                if (routeName == 'PinSubscriptionReportView' || routeName == 'ResellerTransactionReportView' || routeName == 'PaymentReportView' || routeName == 'IndividualSoldPinReportView' || routeName == 'HourlySubscriptionReportView' || routeName == 'CampaignSubscriptionReportView' || routeName == 'CampaignSaleReportView' || routeName == 'OnlineTransactionReportView') {
                    this.reportsActive = true;
                }

                if (routeName == 'AddRatePlans' || routeName == 'RatePlans' || routeName == 'BaseRatePlans' || routeName == 'EditRatePlans' || routeName == 'SaleingRatePlans' || routeName == 'EditSaleRates') {
                    this.rateActive = true;
                }

                if (routeName == 'ResellerLists' || routeName == 'PinLists' || routeName == 'AddPinBatchs' || routeName == 'PinBatchLists' || routeName == 'ResellerConnectedUsers' || routeName == 'AddNewResellers' || routeName == 'EditResellers' || routeName == 'AddSinglePins' || routeName == 'EditBatchs' || routeName == 'PinListBatchWises') {
                    this.clientActive = true;
                }

                if (routeName == 'AddPanelSettings') {
                    this.settingsActive = true;
                }

                if (routeName == 'Home') {
                    this.DashboardActive = true;
                }

                if (routeName == 'HomeAffiliate') {
                    this.affDashboardActive = true;
                }

                if (routeName == 'CampaignLists' || routeName == 'AddBillingAccounts' || routeName == 'BillingAccountLists' || routeName == 'WithdrawLists' || routeName == 'AddNewWithdrawals') {
                    this.campaignActive = true;
                }

                if (routeName == 'FlexPinLists' || routeName == 'FlexAddSinglePins' || routeName == 'FlexAddPinBatchs' || routeName == 'FlexPinBatchLists' || routeName == 'FlexPinSubscriptionReportView' || routeName == 'FlexPaymentReportView') {
                    this.flexActive = true;
                }

            }
        },
        computed: {
            ...mapGetters({
                panelData: 'getPanelData'
            })
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    @media only screen and (max-width: 820px) {
        .nav.child_menu > li > a > span {
            display: block !important;
            padding: 10px 5px;
        }
        .nav-sm .nav.side-menu li a i {
            /*display: inline-flex;*/
        }

        .nav.child_menu > li > a {
            padding: 0;
        }

        .nav.child_menu > li > a > i {
            display: none;
        }

        .db_statistics {
            display: none;
        }
    }

    .hide_child_menu_list {
        display: none;
    }

</style>